import React from 'react';
import PropTypes from 'prop-types';
import { ProbablePitcherInfoWrapper, StatsDividerWrapper } from '../PlayerDuel.style';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';

const ProbablePitcherInfo = ({
    pitchhand,
    jerseyNumber
}) => {
    const handPitch = useTranslator(`${pitchhand === 'R' ? 'probables_rhp' : 'probables_lhp'}`, `${pitchhand}HP`);
    return <ProbablePitcherInfoWrapper>
        <span>{handPitch}</span>
        {jerseyNumber && <>
            <StatsDividerWrapper>|</StatsDividerWrapper>
            <span>#{jerseyNumber}</span>
        </>}
    </ProbablePitcherInfoWrapper>;
};

ProbablePitcherInfo.propTypes = {
    pitchhand: PropTypes.string,
    jerseyNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default ProbablePitcherInfo;
